<ion-header>
  <ion-toolbar>
    <ion-button fill="solid" slot="end" (click)="cancel()">
      <ion-icon slot="start" name="close-circle-outline"></ion-icon>
      {{ 'General.Cancel' | translate }}
    </ion-button>

    <ion-title class="modal-title">{{ title | translate }}</ion-title>
  </ion-toolbar>
</ion-header>

<ion-content>
  <div style="text-align: center; margin-top: 20px; font-weight: bold;">Restaurant: {{offer.LocationName}}</div>
  <div style="text-align: center;" class="expiration">{{'Offer.offerExpire' | translate}} ({{offer.ExpirationDate}})</div>
  <div class="default-content">
    <account-reward-card [cardNumber]="primary.CardNumber" [showQr]="!showPromoCode"
    (showQrChange)="onCardQrShow($event)"></account-reward-card>
    <ion-grid>
      <ion-row style='font-size: 10px;font-weight: bold;'>
        <ion-col style="text-align: center;">
          {{ 'Account.CardNumber' | translate | uppercase }}: {{ primary.CardNumber | chunk_split:4:' '}}
        </ion-col>
      </ion-row>
    </ion-grid>

    <br>

      <div class="promo-container" (click)="onPromotionClicked()">
        <img [hidden]="showPromoCode" class="force-center" [src]="getOfferImage()">
        <qr-code [hidden]="!showPromoCode" class="qr-code force-center" [value]="offer.Id.toString()"></qr-code>
      </div>

      <br>
        <div style="font-size: 18px;font-weight: bold; text-align: center;">{{ 'Offer.PromoCode' | translate }}</div>
        <div style="font-size: 24px; font-weight: bold; text-align: center;">{{ offer.Id }}</div>
        <br>

          @for (item of offer.Choices; track item; let i = $index) {
            <div style="max-width: 300px;margin-left: auto;margin-right:auto;"
              >
              @if (i > 0) {
                <div style="text-align: center;margin-top: 5px;margin-bottom: 5px;font-weight: bold;font-size: 16px;">
                  {{ 'General.Or' | translate | uppercase }}
                </div>
              }
              <div style="text-align: center;font-size: 14px;font-weight: bold;">{{ getItemDescription(item) }}</div>
              <div style="text-align: justify;font-size: 12px;">{{ getItemTerms(item) }}</div>
            </div>
          }
        </div>
      </ion-content>